import {
    REMOVE_GROUP_MAP_ITEM,
    REMOVE_LABEL_INFO,
    REMOVE_NUMBERING_GROUP,
    REMOVE_OPENED_ITEM_NUMBER,
    SET_GROUP_MAP_ITEM,
    SET_LABEL_INFO,
    SET_NUMBERING_GROUP,
    SET_OPENED_ITEM_NUMBER,
} from "./constants";
import {
    IRemoveGroupMapItemAction,
    IRemoveLabelInfoAction,
    IRemoveNumberingGroupAction,
    IRemoveOpenedItemNumberAction,
    ISetGroupMapItemAction,
    ISetLabelInfoAction,
    ISetNumberingGroupAction,
    ISetOpenedItemNumberAction,
    NumberingGroupInfo,
} from "./types";

/**
 * Nastaví údaje o popisku pro otevřenou položku.
 * @param formInstanceId Id otevřené položky, pro kterou se popisek nastaví.
 * @param labelValue Hodnota popisku.
 * @param isLocKey Indikátor, zda je hodnota popisku lokalizační klíč.
 */
export const createSetLabelInfoAction = (formInstanceId: string, labelValue: string | undefined, isLocKey: boolean): ISetLabelInfoAction => ({
    type: SET_LABEL_INFO,
    payload: {
        formInstanceId,
        labelValue,
        isLocKey,
    },
});

/**
 * Odstraní údaje o popisku pro zadanou otevřenou položku.
 * @param formInstanceId
 */
export const createRemoveLabelInfoAction = (formInstanceId: string): IRemoveLabelInfoAction => ({
    type: REMOVE_LABEL_INFO,
    payload: {
        formInstanceId,
    },
});

/**
 * Nastaví záznam pro mapování formInstanceId => groupKey.
 * @param formInstanceId Id otevřené položky.
 * @param groupKey Klíč skupiny pro číslování otevřených položek.
 */
export const createSetGroupMapItemAction = (formInstanceId: string, groupKey: string): ISetGroupMapItemAction => ({
    type: SET_GROUP_MAP_ITEM,
    payload: {
        formInstanceId,
        groupKey,
    },
});

/**
 * Odstraní záznam z mapování formInstanceId => groupKey.
 * @param formInstanceId Id otevřené položky, pro kterou se odstraní záznam.
 */
export const createRemoveGroupMapItemAction = (formInstanceId: string): IRemoveGroupMapItemAction => ({
    type: REMOVE_GROUP_MAP_ITEM,
    payload: {
        formInstanceId,
    },
});

/**
 * Nastaví pořadové číslo pro zadanou otevřenou položku.
 * @param formInstanceId Id otevřené položky.
 * @param number Pořadové číslo.
 */
export const createSetOpenedItemNumberAction = (formInstanceId: string, number: number): ISetOpenedItemNumberAction => ({
    type: SET_OPENED_ITEM_NUMBER,
    payload: {
        formInstanceId,
        number,
    },
});

/**
 * Odstraní záznam s pořadovým číslem pro zadanou otevřenou položku.
 * @param formInstanceId Id otevřené položky.
 */
export const createRemoveOpenedItemNumberAction = (formInstanceId: string): IRemoveOpenedItemNumberAction => ({
    type: REMOVE_OPENED_ITEM_NUMBER,
    payload: {
        formInstanceId,
    },
});

/**
 * Nastaví údaje pro skupinu číslování otevřených položek.
 * @param groupKey Klíč skupiny.
 * @param groupData Údaje o skupině.
 */
export const createSetNumberingGroupAction = (groupKey: string, groupData: NumberingGroupInfo): ISetNumberingGroupAction => ({
    type: SET_NUMBERING_GROUP,
    payload: {
        groupKey,
        groupData,
    },
});

/**
 * Odstraní skupinu číslování.
 * @param groupKey Klíč skupiny k odstranění.
 */
export const createRemoveNumberingGroupAction = (groupKey: string): IRemoveNumberingGroupAction => ({
    type: REMOVE_NUMBERING_GROUP,
    payload: {
        groupKey,
    },
});
